export default __webpack_public_path__ + "static/media/brand_scotiabank.a524e9bf.svg";